/* ============================================================================
   MailBakes — quantities on the "Includes:" line
   assets/mb-cart-includes.js

   sections/mb-cart.liquid builds that line by appending each add-on's variant
   title once per LINE, never its quantity:

     {%- assign addons = addons | append: c.variant.title | append: ', ' -%}

   So three Yorkshire Teas read as one. This rewrites the line from /cart.js
   with the quantity appended.

   It REBUILDS the string from the cart rather than string-patching the
   rendered text — parsing "a, b, c" back apart would break on any add-on whose
   own name contains a comma.

   Doing it here rather than in the Liquid keeps that 35KB hand-tuned section
   untouched. The one-line Liquid fix is the better long-term home; it is in
   the install guide. Delete this file once that lands.

   Mirrors the section's own rules: children are matched on _mb_parent_group,
   and the postage line is excluded, because postage has its own row in the
   summary and is deliberately kept out of "Includes".
   ============================================================================ */

(function () {
  'use strict';

  var root = document.querySelector('[data-mb-cart]');
  if (!root) return;

  var DELIVERY_HANDLE = 'mb-delivery';

  function nameOf(item) {
    var t = item.variant_title;
    /* Single-variant add-ons report "Default Title", which is meaningless on a
       picking bench — fall back to the product name. */
    if (!t || t === 'Default Title') return item.product_title;
    return t;
  }

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      [].forEach.call(root.querySelectorAll('.mb-line[data-group]'), function (row) {
        var group = row.getAttribute('data-group');
        if (!group) return;

        var kids = cart.items.filter(function (it) {
          var p = it.properties || {};
          return p._mb_parent_group === group && it.handle !== DELIVERY_HANDLE;
        });
        if (!kids.length) return;

        /* Nothing to correct unless something is actually stacked. Skipping
           here means the common case never touches the DOM, so there is no
           flash of the line being rewritten. */
        var stacked = kids.some(function (k) { return k.quantity > 1; });
        if (!stacked) return;

        var text = kids.map(function (k) {
          return nameOf(k) + (k.quantity > 1 ? ' x' + k.quantity : '');
        }).join(', ');

        /* The "Includes:" label is the only <b> in the spec block ending in a
           colon — the other one is the slice count ("Two Slices"). The text
           node straight after it holds the list. */
        var labels = [].filter.call(row.querySelectorAll('.mb-line__sp b'), function (el) {
          return /:\\s*$/.test(el.textContent);
        });
        var label = labels[labels.length - 1];
        if (!label) return;

        var next = label.nextSibling;
        if (next && next.nodeType === 3) next.nodeValue = ' ' + text;
      });
    })
    .catch(function () { /* the line is still correct, just without quantities */ });
})();